enum StayDuration {
  TWO_DAYS = '2',
  THREE_DAYS = '3',
  FIVE_DAYS = '5',
  SEVEN_DAYS = '7',
  TEN_DAYS = '10',
  FOURTEEN_DAYS = '14',
}

export { StayDuration };
